export const actionTypes = {
  REQUEST_START: 'AUTHORIZATION.GET_CAPTCHA.REQUEST_START',
  SUCCESS: 'AUTHORIZATION.GET_CAPTCHA.SUCCESS',
  FAILURE: 'AUTHORIZATION.GET_CAPTCHA.FAILURE',
};

export function startRequest(inn) {
  return {
    type: actionTypes.REQUEST_START,
    payload: inn,
  };
}

export function requestSuccess(captcha) {
  return {
    type: actionTypes.SUCCESS,
    payload: captcha,
  };
}

export function requestFailure(error) {
  return {
    type: actionTypes.FAILURE,
    payload: error,
  };
}
